<template>
  <div id="fotos" class="gallerie desktop-fotos">
    <img
      @click="openGallery(0)"
      class="absolute bp p1"
      src="@/assets/images/gallerie/p1.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200 }"
    />
    <img
      @click="openGallery(1)"
      class="absolute np p2"
      src="@/assets/images/gallerie/p2.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200, distance: '100px', origin: 'left' }"
    />
    <img
      @click="openGallery(2)"
      class="absolute np p3"
      src="@/assets/images/gallerie/p3.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200, distance: '100px', origin: 'right' }"
    />
    <img
      @click="openGallery(3)"
      class="absolute bp p4"
      src="@/assets/images/gallerie/p4.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200 }"
    />
    <img
      @click="openGallery(4)"
      class="absolute np p5"
      src="@/assets/images/gallerie/p5.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200, distance: '100px', origin: 'left' }"
    />
    <img
      @click="openGallery(5)"
      class="absolute np p6"
      src="@/assets/images/gallerie/p6.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200, distance: '100px', origin: 'right' }"
    />
    <img
      @click="openGallery(6)"
      class="absolute bp p7"
      src="@/assets/images/gallerie/p7.jpg"
      alt=""
      v-scroll-reveal="{ delay: 200 }"
    />
    <BaseModalGallery :index="index" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: null,
    }
  },
  methods: {
    openGallery(number) {
      this.index = number
    },
  },
}
</script>

<style lang="scss" scoped>
.gallerie {
  position: relative;
  padding-block: 4em;
  height: 2380px;
  overflow-x: hidden;
  background-color: white;
  .absolute {
    position: absolute;
  }
  .bp {
    left: 50%;
    margin-left: -512px;
  }
  .p1 {
    top: 28px;
  }
  .p2,
  .p3 {
    top: 496px;
  }
  .p4 {
    top: 959px;
  }
  .p5,
  .p6 {
    top: 1422px;
  }
  .p7 {
    top: 1903px;
  }
  .p2,
  .p5 {
    right: 50%;
    margin-right: 14px;
  }
  .p3,
  .p6 {
    left: 50%;
    margin-left: 14px;
  }
}
</style>
